import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRow from '../elements/InputRow'
import FancySelectExpiry from '../elements/FancySelectExpiry'
import globals from '../globals'
import InputRowReadOnly from '../elements/InputRowReadOnly'

const options = {
    postUrl: '/api/postPayAccount',
    success: 'Success! Your payment has been made successfully.'
}
const state = {}

class PayAccountForm extends React.Component {
    componentDidMount () {
        if (this.props.additionalFields) {
            this.props.setDynamicValues({
                ...this.props.additionalFields,
                amount: this.props.failedAmount > 0 ? this.props.failedAmount : this.props.accountBalance
            })
        } else {
            this.props.setDynamicValues({
                amount: this.props.failedAmount > 0 ? this.props.failedAmount : this.props.accountBalance
            })
        }
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        if (prevProps.failedAmount !== this.props.failedAmount) {
            this.props.setDynamicValues({
                amount: this.props.failedAmount > 0 ? this.props.failedAmount : this.props.accountBalance
            })
        }

        if (this.props.additionalFields && prevProps.additionalFields !== this.props.additionalFields) {
            this.props.setDynamicValues(this.props.additionalFields)
        }
    }

    handleAmountBlur (event) {
        let newValue = parseFloat(event.target.value)
        if (!newValue) {
            newValue = 0
        }

        event.target.value = globals.addDecimals(newValue)
    };

    handleOnFocus (event) {
        event.target.select()
    };

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                {this.props.failedAmount > 0
                    ? <InputRowReadOnly label='Amount to pay ($)' value={this.props.values.amount} />
                    : <InputRow
                        label='Amount to pay ($)'
                        name='amount'
                        placeholder='XX.XX'
                        type='tel'
                        value={this.props.values.amount}
                        errors={this.props.errors}
                        handleChange={this.props.handleInputChange}
                        handleOnBlur={this.handleAmountBlur.bind(this)}
                        handleOnFocus={this.handleOnFocus.bind(this)}
                    />}
                <InputRow
                    label='Card number'
                    name='credit_card_number'
                    placeholder='Credit/debit card number'
                    type='tel'
                    value={this.props.values.credit_card_number}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                />
                <InputRow
                    label='Name on card'
                    name='credit_card_holder_name'
                    placeholder='Name on card'
                    value={this.props.values.credit_card_holder_name}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                />
                <FancySelectExpiry
                    cardMonth={this.props.values.cardMonth}
                    cardYear={this.props.values.cardYear}
                    errors={this.props.errors}
                    handleChange={this.props.setDynamicValues}
                />
                <InputRow
                    label='CCV code'
                    name='credit_card_cvc'
                    placeholder='CCV'
                    type='tel'
                    value={this.props.values.credit_card_cvc}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                    maxLength='3'
                />

                {this.props.children}

                <div className='mt-3 d-flex align-items-center flex-column flex-md-row text-center text-md-left'>
                    <div className='mr-md-4 flex-shrink-0'>
                        <Button title='Pay Account' action={this.props.handleSubmit} />
                    </div>
                    <div>
                        <p><small>
                            Payments made by debit or credit card incur a 1.0% transaction fee
                        </small>
                        </p>
                    </div>
                </div>
            </form>
        )
    }
}

export default FormHOC(PayAccountForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/PayAccountForm.js